/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** TaskStatus */
export type TaskStatus = "processing" | "completed" | "error";

/** ScoreLevel */
export type ScoreLevel = "excellent" | "good" | "attention" | "critical";

/** ReportStatus */
export type ReportStatus = "pending" | "ready" | "failed";

/** ReleaseReason */
export type ReleaseReason =
  | "microphone_denied"
  | "microphone_unavailable"
  | "recorder_failed"
  | "declined_by_designer";

/** IntentState */
export type IntentState =
  | "pending"
  | "claimed"
  | "recording"
  | "finished"
  | "cancelled"
  | "expired";

/** FormState */
export type FormState = "not_started" | "processing" | "completed" | "failed";

/** CriterionMark */
export type CriterionMark = "not_met" | "partial" | "met" | "unscored";

/** Body_upload_record */
export interface BodyUploadRecord {
  /** File */
  file: File | Blob;
}

/** ClaimIn */
export interface ClaimIn {
  /**
   * Device Id
   * Стабильный идентификатор вкладки; владелец намерения
   * @minLength 1
   * @maxLength 64
   */
  device_id: string;
}

/** ClientJourney */
export interface ClientJourney {
  /** Short Summary */
  short_summary: string;
}

/** ClientMeetingsResponse */
export interface ClientMeetingsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designer Email */
  designer_email: string;
  /** Client Profile */
  client_profile: string;
  /** Meetings */
  meetings: MeetingBrief[];
}

/** ClientRoleplayPatchIn */
export interface ClientRoleplayPatchIn {
  /** Is Roleplay */
  is_roleplay: boolean;
}

/** ClientRoleplayResponse */
export interface ClientRoleplayResponse {
  /** Designer Email */
  designer_email: string;
  /** Client Profile */
  client_profile: string;
  /** Is Roleplay */
  is_roleplay: boolean;
}

/** ClientSummary */
export interface ClientSummary {
  /** Profile Name */
  profile_name: string;
  /** Meetings Count */
  meetings_count: number;
  /** Scored Meetings Count */
  scored_meetings_count: number;
  /** Recorded Meetings Count */
  recorded_meetings_count: number;
  /** Recorded Duration Min */
  recorded_duration_min: number;
  /** Scoring In Progress */
  scoring_in_progress: boolean;
  /** Avg Score */
  avg_score: number | null;
  /** Last Meeting At */
  last_meeting_at: string | null;
  summary: ClientJourney;
  form: FormBrief | null;
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
}

/** CopilotCreateIn */
export interface CopilotCreateIn {
  /**
   * Profile Name
   * @default "unknown"
   */
  profile_name?: string;
}

/** CopilotFinalized */
export interface CopilotFinalized {
  /** Session Id */
  session_id: string;
  /** Output Dir */
  output_dir: string;
}

/** CopilotSessionCreated */
export interface CopilotSessionCreated {
  /** Session Id */
  session_id: string;
  /** Status */
  status: string;
  /** Analysis Interval Sec */
  analysis_interval_sec: number;
  /**
   * Checkpoints
   * @default {}
   */
  checkpoints?: Record<string, number>;
}

/** CopilotSessionOut */
export interface CopilotSessionOut {
  /** Session Id */
  session_id: string;
  /** Profile Name */
  profile_name: string;
  /** Chunk Count */
  chunk_count: number;
  /** Total Duration Sec */
  total_duration_sec: number;
  /** Created At */
  created_at: string;
  /** Last Updated */
  last_updated: string;
  /** Anchored Facts */
  anchored_facts: string[];
  /** Unaddressed Flags */
  unaddressed_flags: string[];
}

/** CopilotSummaryOut */
export interface CopilotSummaryOut {
  /**
   * Short Summary
   * @default ""
   */
  short_summary?: string;
  /**
   * Topics
   * @default []
   */
  topics?: CopilotSummaryBullet[];
  /**
   * Client Info
   * @default []
   */
  client_info?: CopilotSummaryBullet[];
  /**
   * Agreed
   * @default []
   */
  agreed?: CopilotAgreedItem[];
  /**
   * Follow Up
   * @default []
   */
  follow_up?: string[];
  /**
   * Breakdown
   * @default []
   */
  breakdown?: CopilotBreakdownItem[];
  [key: string]: any;
}

/** CopilotSummaryBullet */
export interface CopilotSummaryBullet {
  /** Text */
  text: string;
  /**
   * Icon
   * Lucide kebab-case icon name
   * @default ""
   */
  icon?: string;
}

/** CopilotAgreedItem */
export interface CopilotAgreedItem {
  /** Text */
  text: string;
  /**
   * Done
   * true if commitment was completed on the meeting
   * @default true
   */
  done?: boolean;
}

/** CopilotBreakdownItem */
export interface CopilotBreakdownItem {
  /** T Sec */
  t_sec: number;
  /** Title */
  title: string;
  /**
   * Detail
   * @default ""
   */
  detail?: string;
}

/** CriterionOut */
export interface CriterionOut {
  /**
   * Code
   * Код критерия M1-M9, стабилен между версиями
   */
  code: string;
  /**
   * Title
   * Название критерия для отображения
   */
  title: string;
  /**
   * Weight
   * Вес критерия; сумма по всем = 100
   * @min 0
   * @max 100
   */
  weight: number;
  /** Уровень выполнения; unscored — критерий оценить не удалось */
  mark: CriterionMark;
  /**
   * Score
   * Балл: not_met=0, partial=0.5, met=1, unscored=0
   * @min 0
   * @max 1
   */
  score: number;
  /**
   * Rationale
   * Обоснование оценки
   */
  rationale: string;
  /**
   * Evidence
   * Дословные цитаты из стенограммы, на которых основана оценка
   */
  evidence: string[];
  /**
   * Improvement
   * Что дизайнеру сделать иначе; пусто при mark=met
   */
  improvement: string;
  /**
   * Timecode
   * MM:SS момента оценки; пусто, если нет
   */
  timecode: string;
}

/** DesignerClientsResponse */
export interface DesignerClientsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designer Email */
  designer_email: string;
  /** Clients */
  clients: ClientSummary[];
}

/** DesignerConversionStatsResponse */
export interface DesignerConversionStatsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designers */
  designers: DesignerConversionStatsRow[];
}

/** DesignerConversionStatsRow */
export interface DesignerConversionStatsRow {
  /** Email */
  email: string;
  /** Conversion Count */
  conversion_count: number | null;
}

/** DesignerCriterionAvg */
export interface DesignerCriterionAvg {
  /** Code */
  code: string;
  /** Title */
  title: string;
  /** Avg Pct */
  avg_pct: number | null;
}

/** DesignerFlagStatsResponse */
export interface DesignerFlagStatsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designers */
  designers: DesignerFlagStatsRow[];
}

/** DesignerFlagStatsRow */
export interface DesignerFlagStatsRow {
  /** Email */
  email: string;
  /** M1 Avg Pct */
  m1_avg_pct: number | null;
  /** M2 Avg Pct */
  m2_avg_pct: number | null;
  /** M3 Avg Pct */
  m3_avg_pct: number | null;
  /** M4 Avg Pct */
  m4_avg_pct: number | null;
  /** M5 Avg Pct */
  m5_avg_pct: number | null;
  /** M6 Avg Pct */
  m6_avg_pct: number | null;
  /** M7 Avg Pct */
  m7_avg_pct: number | null;
  /** M8 Avg Pct */
  m8_avg_pct: number | null;
  /** M9 Avg Pct */
  m9_avg_pct: number | null;
  /** Logic Avg Pct */
  logic_avg_pct: number | null;
  /** Mood Avg Pct */
  mood_avg_pct: number | null;
  /** Extra Zones Avg Pct */
  extra_zones_avg_pct: number | null;
  /** Avg Duration Min */
  avg_duration_min: number | null;
  /** Scored Meetings Count */
  scored_meetings_count: number;
}

/** DesignerMetricPoint */
export interface DesignerMetricPoint {
  /** Label */
  label: string;
  /** Value */
  value: number | null;
}

/** DesignerMetricSeries */
export interface DesignerMetricSeries {
  /** Metric */
  metric: string;
  /** Points */
  points: DesignerMetricPoint[];
}

/** DesignerPanelStatsResponse */
export interface DesignerPanelStatsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designer Email */
  designer_email: string;
  /** Meetings Count */
  meetings_count: number;
  /** Problematic Meetings Count */
  problematic_meetings_count: number;
  /** Scored Meetings Count */
  scored_meetings_count: number;
  /** Avg Score */
  avg_score: number | null;
  /** Conversion Count */
  conversion_count: number | null;
  /** Granularity */
  granularity: "day" | "hour";
  /** Metric Series */
  metric_series: DesignerMetricSeries[];
  /** Criteria */
  criteria: DesignerCriterionAvg[];
  /** Schedule Meetings */
  schedule_meetings: DesignerScheduleMeeting[];
  /** Typical Issues */
  typical_issues: TypicalIssueRow[];
}

/** DesignerScheduleMeeting */
export interface DesignerScheduleMeeting {
  /** Meeting Id */
  meeting_id: string;
  /** Client Name */
  client_name: string;
  /** Started At */
  started_at: string | null;
  /** Ended At */
  ended_at: string | null;
  /** Duration Min */
  duration_min: number;
  /** Score */
  score: number | null;
  /** Score Level */
  score_level: string | null;
  /** Scoring Status */
  scoring_status: string;
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
}

/** DesignerSummary */
export interface DesignerSummary {
  /** Email */
  email: string;
  /** Salon Names */
  salon_names: string[];
  /** Meetings Count */
  meetings_count: number;
  /** Clients Count */
  clients_count: number;
  /** Scored Meetings Count */
  scored_meetings_count: number;
  /** Problematic Meetings Count */
  problematic_meetings_count: number;
  /** Avg Score */
  avg_score: number | null;
  /** Last Meeting At */
  last_meeting_at: string | null;
}

/** DesignersResponse */
export interface DesignersResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Designers */
  designers: DesignerSummary[];
}

/** FormAccepted */
export interface FormAccepted {
  /** Task Id */
  task_id: string;
}

/** FormBrief */
export interface FormBrief {
  /** Status */
  status: string;
  /** Fio */
  fio: string;
  /** Phone */
  phone: string;
  /** Fields Total */
  fields_total: number;
  /** Fields Filled */
  fields_filled: number;
  /** Fields Empty */
  fields_empty: number;
  /** Updated At */
  updated_at: string | null;
}

/** FormCreateIn */
export interface FormCreateIn {
  /** Phone */
  phone: string;
  /**
   * Demo Tour
   * When true (interactive demo tour), backend may serve a prebuilt seed profile.
   * @default false
   */
  demo_tour?: boolean;
}

/** FormDetail */
export interface FormDetail {
  /** Status */
  status: string;
  /** Fio */
  fio: string;
  /** Phone */
  phone: string;
  /** Fields Total */
  fields_total: number;
  /** Fields Filled */
  fields_filled: number;
  /** Fields Empty */
  fields_empty: number;
  /** Updated At */
  updated_at: string | null;
  /** Fields */
  fields: FormField[];
}

/** FormField */
export interface FormField {
  /** Name */
  name: string;
  /** Filled */
  filled: boolean;
  /** Value */
  value: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IntentOut */
export interface IntentOut {
  /**
   * Intent Id
   * @format uuid
   */
  intent_id: string;
  /**
   * Clientmeeting
   * @min 0
   * @max 999999999
   */
  clientmeeting: number;
  /** Client Phone */
  client_phone: string;
  /** Profile Name */
  profile_name: string;
  /**
   * Session Id
   * Копайлот-сессия, к которой крепится запись
   */
  session_id: string;
  state: IntentState;
  /**
   * Auto Start
   * Запись должна стартовать без действий дизайнера; после окна автостарта остаётся ручной запуск того же намерения
   */
  auto_start: boolean;
  /**
   * Attempts
   * Сколько раз запуск срывался
   * @min 0
   */
  attempts: number;
  /**
   * Last Error
   * Причина последнего срыва запуска
   */
  last_error: string | null;
  /**
   * Expires At
   * @format date-time
   */
  expires_at: string;
}

/** IntentsOut */
export interface IntentsOut {
  /** Intents */
  intents: IntentOut[];
}

/** LaunchResolveOut */
export interface LaunchResolveOut {
  /** Session Id */
  session_id: string;
  /** Phone */
  phone: string;
  /** Designer Email */
  designer_email: string;
  /** Profile Name */
  profile_name: string;
  /** Clientmeeting */
  clientmeeting: number;
  /**
   * Intent Id
   * Намерение этой встречи, если оно ещё открыто: приложение забирает его так же, как при автозапуске, поэтому ссылка и автостарт не спорят за одну встречу
   */
  intent_id?: string | null;
}

/** LaunchStateOut */
export interface LaunchStateOut {
  /**
   * Clientmeeting
   * @min 0
   * @max 999999999
   */
  clientmeeting: number;
  /** Designer Email */
  designer_email: string;
  /** pending — ждём дизайнера; claimed — приложение забрало запуск; recording — идёт запись; finished — встреча записана; expired — дизайнер так и не открыл приложение */
  state: IntentState;
  /** Auto Start */
  auto_start: boolean;
  /**
   * Attempts
   * @min 0
   */
  attempts: number;
  /** Last Error */
  last_error: string | null;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Started At */
  started_at: string | null;
}

/** MeOut */
export interface MeOut {
  /** User */
  user: string;
  /** Role */
  role: string;
  /** Salon Id */
  salon_id: string | null;
  /** Available Salons */
  available_salons: SalonOptionOut[];
}

/** MeetingBrief */
export interface MeetingBrief {
  /** Meeting Id */
  meeting_id: string;
  /** Started At */
  started_at: string;
  /** Last Session End */
  last_session_end: string;
  /** Duration Min */
  duration_min: number;
  /** Session Count */
  session_count: number;
  /** Score */
  score: number | null;
  /** Score Level */
  score_level: string | null;
  /** Scoring Status */
  scoring_status:
    | "pending"
    | "scoring"
    | "scored"
    | "failed"
    | "skipped"
    | "empty";
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
}

/** MeetingDetailResponse */
export interface MeetingDetailResponse {
  /** Meeting Id */
  meeting_id: string;
  /** Designer Email */
  designer_email: string;
  /** Client Profile */
  client_profile: string;
  /** Started At */
  started_at: string;
  /** Last Session End */
  last_session_end: string;
  /** Duration Min */
  duration_min: number;
  /** Session Count */
  session_count: number;
  /** Score */
  score: number | null;
  /** Score Level */
  score_level: string | null;
  /** Scoring Status */
  scoring_status:
    | "pending"
    | "scoring"
    | "scored"
    | "failed"
    | "skipped"
    | "empty";
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
  /** Sessions */
  sessions: MeetingSession[];
  /** Records */
  records: MeetingRecordBrief[];
  /** Scoring */
  scoring: Record<string, any> | null;
  /** Summary */
  summary: Record<string, any> | null;
  form: FormDetail | null;
}

/** MeetingRecordBrief */
export interface MeetingRecordBrief {
  /** File Id */
  file_id: string;
  /** Name */
  name: string;
  /** Date */
  date: string;
  /** Session Id */
  session_id?: string | null;
}

/** MeetingReportOut */
export interface MeetingReportOut {
  /**
   * Schema Version
   * Версия контракта; минорные версии только добавляют поля
   * @default "1.0"
   */
  schema_version?: string;
  /** pending — анализ ещё идёт, повторите позже; ready — данные финальны; failed — встречу оценить нечем (пустая запись или разговор не состоялся), повторять бессмысленно */
  status: ReportStatus;
  /**
   * Clientmeeting
   * @min 0
   * @max 999999999
   */
  clientmeeting: number;
  /** Designer Email */
  designer_email: string;
  /** Started At */
  started_at: string | null;
  /** Ended At */
  ended_at: string | null;
  /**
   * Duration Min
   * @min 0
   */
  duration_min: number;
  /**
   * Session Count
   * Число сессий записи внутри одной встречи
   * @min 0
   */
  session_count: number;
  /** Заполнено только при status=ready */
  summary: MeetingSummaryOut | null;
  /** Заполнено только при status=ready */
  score: MeetingScoreOut | null;
}

/** MeetingScoreOut */
export interface MeetingScoreOut {
  /**
   * Total Score
   * Итоговый балл встречи по 100-балльной шкале
   * @min 0
   * @max 100
   */
  total_score: number;
  level: ScoreLevel;
  /** Criteria */
  criteria: CriterionOut[];
  /**
   * Scored Criteria
   * Сколько критериев удалось оценить. Меньше длины criteria означает, что часть критериев не оценена (mark=unscored) и итоговый балл занижен
   * @min 0
   */
  scored_criteria: number;
  /**
   * Scored At
   * Когда оценка была посчитана
   */
  scored_at: string | null;
}

/** MeetingSession */
export interface MeetingSession {
  /** Session Id */
  session_id: string;
  /** Started At */
  started_at: string;
  /** Finalized At */
  finalized_at: string | null;
  /** Duration Min */
  duration_min: number | null;
  /** Final Phase */
  final_phase: string;
  /** Spin Used */
  spin_used: string[];
}

/** MeetingSummaryOut */
export interface MeetingSummaryOut {
  /**
   * Short Summary
   * Связный пересказ встречи, 2-4 предложения
   */
  short_summary: string;
  /**
   * Topics
   * Ключевые темы разговора
   */
  topics: string[];
  /**
   * Client Info
   * Запрос, проблема и пожелания клиента
   */
  client_info: string[];
  /**
   * Agreed
   * Договорённости и следующие шаги
   */
  agreed: string[];
  /**
   * Follow Up
   * Открытые вопросы
   */
  follow_up: string[];
}

/** MergedPresentationsOut */
export type MergedPresentationsOut = Record<string, Record<string, any>>;

/** PartReceived */
export interface PartReceived {
  /** Status */
  status: string;
  /** Part Number */
  part_number: number;
}

/** PartnerStartIn */
export interface PartnerStartIn {
  /** Designer Email */
  designer_email: string;
  /** Client Phone */
  client_phone: string;
  /**
   * Clientmeeting
   * @min 0
   * @max 999999999
   */
  clientmeeting: number;
}

/** PartnerStartOut */
export interface PartnerStartOut {
  /** Session Id */
  session_id: string;
  /** Launch Url */
  launch_url: string;
  /** Created At */
  created_at: string;
}

/** PresentationItemIn */
export interface PresentationItemIn {
  /** Item */
  item: Record<string, any>;
}

/** PresentationItemKey */
export interface PresentationItemKey {
  /** Key */
  key: string;
}

/** ProfileDetailOut */
export interface ProfileDetailOut {
  /** Name */
  name: string;
  /** Client Id */
  client_id?: string | null;
  /** Forms */
  forms: Record<string, any>[];
  /** Records */
  records: RecordOut[];
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
}

/** ProfileIndexOut */
export interface ProfileIndexOut {
  /** Index */
  index: Record<string, string[]>;
}

/** ProfilePatchIn */
export interface ProfilePatchIn {
  /** Name */
  name: string;
}

/** ProfileRoleplayPatchIn */
export interface ProfileRoleplayPatchIn {
  /** Is Roleplay */
  is_roleplay: boolean;
}

/** ProfileSearchOut */
export interface ProfileSearchOut {
  /** Items */
  items: ProfileSummaryOut[];
  /** Total */
  total: number;
  /** Limit */
  limit: number;
  /** Offset */
  offset: number;
}

/** ProfileSummaryOut */
export interface ProfileSummaryOut {
  /** Name */
  name: string;
  /** Client Id */
  client_id?: string | null;
  /** Tags */
  tags: string[];
  status: FormState;
  /** Task Id */
  task_id: string;
  /** Phone */
  phone: string;
  /** Error */
  error: string;
  /**
   * Is Roleplay
   * @default false
   */
  is_roleplay?: boolean;
}

/** RecordOut */
export interface RecordOut {
  /** Id */
  id: string;
  /** Date */
  date: string;
  /** Name */
  name: string;
  /** File Id */
  file_id: string;
  /** Copilot Session Id */
  copilot_session_id?: string | null;
}

/** RecordPatchIn */
export interface RecordPatchIn {
  /** Name */
  name: string;
}

/** ReleaseIn */
export interface ReleaseIn {
  /**
   * Device Id
   * Стабильный идентификатор вкладки; владелец намерения
   * @minLength 1
   * @maxLength 64
   */
  device_id: string;
  reason: ReleaseReason;
}

/** SalonAnalyticsInterpretation */
export interface SalonAnalyticsInterpretation {
  /** Headline */
  headline: string;
  /** Points */
  points: SalonAnalyticsInterpretationPoint[];
}

/** SalonAnalyticsInterpretationPoint */
export interface SalonAnalyticsInterpretationPoint {
  /** Observation */
  observation: string;
  /** Action */
  action: string;
}

/** SalonAnalyticsInterpretationResponse */
export interface SalonAnalyticsInterpretationResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  interpretation: SalonAnalyticsInterpretation | null;
}

/** SalonAnalyticsResponse */
export interface SalonAnalyticsResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Meetings Count */
  meetings_count: number;
  /** Meetings Count Delta */
  meetings_count_delta: number | null;
  /** Avg Score */
  avg_score: number | null;
  /** Problematic Share */
  problematic_share: number | null;
  /** Conversion */
  conversion: number | null;
  /** Avg Duration Min */
  avg_duration_min: number | null;
  /** Strongest Criteria */
  strongest_criteria: SalonCriterionStat[];
  /** Weakest Criteria */
  weakest_criteria: SalonCriterionStat[];
  /** Improved Criteria */
  improved_criteria: SalonCriterionStat[];
  /** Worsened Criteria */
  worsened_criteria: SalonCriterionStat[];
}

/** SalonCriterionStat */
export interface SalonCriterionStat {
  /** Code */
  code: string;
  /** Title */
  title: string;
  /** Avg Pct */
  avg_pct: number;
  /** Delta Pp */
  delta_pp?: number | null;
  /**
   * Designers
   * @default []
   */
  designers?: string[];
}

/** SalonOptionOut */
export interface SalonOptionOut {
  /** Id */
  id: string;
  /** Name */
  name: string;
}

/** TaskOut */
export interface TaskOut {
  /** Task Id */
  task_id: string;
  status: TaskStatus;
  /** Created At */
  created_at: string;
  /** Completed At */
  completed_at?: string | null;
  /** Profile Name */
  profile_name?: string | null;
  /** Error */
  error?: string | null;
}

/** TypicalIssueRow */
export interface TypicalIssueRow {
  /** Rank */
  rank: number;
  /** Issue Code */
  issue_code: string;
  /** Issue Title */
  issue_title: string;
  /** Criterion Code */
  criterion_code: string;
  /** Criterion Title */
  criterion_title: string;
  /** Meetings Pct */
  meetings_pct: number | null;
  /** Delta Pp */
  delta_pp: number | null;
  /** Meetings Count */
  meetings_count: number;
  /** Designers */
  designers: string[];
}

/** TypicalIssuesResponse */
export interface TypicalIssuesResponse {
  /** From */
  from?: string | null;
  /** To */
  to?: string | null;
  /** Salon Id */
  salon_id: string | null;
  /** Scored Meetings Count */
  scored_meetings_count: number;
  /** Issues */
  issues: TypicalIssueRow[];
}

/** UploadCompleteIn */
export interface UploadCompleteIn {
  /** Profile Key */
  profile_key: string;
  /** Creation Date */
  creation_date: string;
  /** Total Parts */
  total_parts: number;
  /** Copilot Session Id */
  copilot_session_id?: string | null;
}

/** UploadCompleted */
export interface UploadCompleted {
  /** Status */
  status: string;
  /** Id */
  id?: string | null;
  /** File Id */
  file_id?: string | null;
  /** Name */
  name?: string | null;
  /** Date */
  date?: string | null;
  /** Copilot Session Id */
  copilot_session_id?: string | null;
  [key: string]: any;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === "multipart/form-data" &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === "text/plain" &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title recommendation_system
 * @version 1
 */
export class API<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @tags profiles
     * @name SearchProfiles
     * @summary Search Profiles
     * @request GET:/v1/profiles
     */
    searchProfiles: (
      query?: {
        /** Q */
        q?: string[] | null;
        /**
         * Limit
         * @min 1
         * @max 500
         * @default 20
         */
        limit?: number;
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProfileSearchOut, HTTPValidationError>({
        path: `/v1/profiles`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profiles
     * @name GetProfile
     * @summary Get Profile
     * @request GET:/v1/profiles/{profile_key}
     */
    getProfile: (profileKey: string, params: RequestParams = {}) =>
      this.request<
        ProfileDetailOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profiles
     * @name RenameProfile
     * @summary Rename Profile
     * @request PATCH:/v1/profiles/{profile_key}
     */
    renameProfile: (
      profileKey: string,
      data: ProfilePatchIn,
      params: RequestParams = {},
    ) =>
      this.request<
        ProfileDetailOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}`,
        method: "PATCH",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profiles
     * @name DeleteProfile
     * @summary Delete Profile
     * @request DELETE:/v1/profiles/{profile_key}
     */
    deleteProfile: (profileKey: string, params: RequestParams = {}) =>
      this.request<
        void,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profiles
     * @name SetProfileRoleplay
     * @summary Set Profile Roleplay
     * @request PATCH:/v1/profiles/{profile_key}/roleplay
     */
    setProfileRoleplay: (
      profileKey: string,
      data: ProfileRoleplayPatchIn,
      params: RequestParams = {},
    ) =>
      this.request<
        ProfileDetailOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/roleplay`,
        method: "PATCH",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags profiles
     * @name IndexProfiles
     * @summary Index Profiles
     * @request GET:/v1/profile-index
     */
    indexProfiles: (params: RequestParams = {}) =>
      this.request<ProfileIndexOut, HTTPValidationError>({
        path: `/v1/profile-index`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags records
     * @name ListRecords
     * @summary List Records
     * @request GET:/v1/profiles/{profile_key}/records
     */
    listRecords: (profileKey: string, params: RequestParams = {}) =>
      this.request<
        RecordOut[],
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/records`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags records
     * @name UploadRecord
     * @summary Upload Record
     * @request POST:/v1/profiles/{profile_key}/records
     */
    uploadRecord: (
      profileKey: string,
      data: BodyUploadRecord,
      params: RequestParams = {},
    ) =>
      this.request<
        RecordOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/records`,
        method: "POST",
        body: data,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags records
     * @name RenameRecord
     * @summary Rename Record
     * @request PATCH:/v1/profiles/{profile_key}/records/{record_id}
     */
    renameRecord: (
      recordId: string,
      profileKey: string,
      data: RecordPatchIn,
      params: RequestParams = {},
    ) =>
      this.request<
        RecordOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/records/${recordId}`,
        method: "PATCH",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags records
     * @name DeleteRecord
     * @summary Delete Record
     * @request DELETE:/v1/profiles/{profile_key}/records/{record_id}
     */
    deleteRecord: (
      recordId: string,
      profileKey: string,
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/records/${recordId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags records
     * @name GetRecordAudio
     * @summary Get Record Audio
     * @request GET:/v1/profiles/{profile_key}/records/{record_id}
     */
    getRecordAudio: (
      recordId: string,
      profileKey: string,
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/records/${recordId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags forms
     * @name CreateForm
     * @summary Create Form
     * @request POST:/v1/profiles/{profile_key}/forms
     */
    createForm: (
      profileKey: string,
      data: FormCreateIn,
      params: RequestParams = {},
    ) =>
      this.request<
        FormAccepted,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/forms`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags presentation
     * @name GetPresentation
     * @summary Get Presentation
     * @request GET:/v1/profiles/{profile_key}/presentation
     */
    getPresentation: (
      profileKey: string,
      query: {
        /** Phone */
        phone: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/presentation`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags presentation
     * @name CreatePresentationItem
     * @summary Create Presentation Item
     * @request POST:/v1/profiles/{profile_key}/presentation/items
     */
    createPresentationItem: (
      profileKey: string,
      query: {
        /** Phone */
        phone: string;
      },
      data: PresentationItemIn,
      params: RequestParams = {},
    ) =>
      this.request<
        PresentationItemKey,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/presentation/items`,
        method: "POST",
        query: query,
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags presentation
     * @name UpdatePresentationItem
     * @summary Update Presentation Item
     * @request PUT:/v1/profiles/{profile_key}/presentation/items/{item_key}
     */
    updatePresentationItem: (
      itemKey: string,
      profileKey: string,
      query: {
        /** Phone */
        phone: string;
      },
      data: PresentationItemIn,
      params: RequestParams = {},
    ) =>
      this.request<
        PresentationItemKey,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/presentation/items/${itemKey}`,
        method: "PUT",
        query: query,
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags presentation
     * @name DeletePresentationItem
     * @summary Delete Presentation Item
     * @request DELETE:/v1/profiles/{profile_key}/presentation/items/{item_key}
     */
    deletePresentationItem: (
      itemKey: string,
      profileKey: string,
      query: {
        /** Phone */
        phone: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        void,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/profiles/${profileKey}/presentation/items/${itemKey}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags presentation
     * @name MergedPresentations
     * @summary Merged Presentations
     * @request GET:/v1/presentations/merged
     */
    mergedPresentations: (params: RequestParams = {}) =>
      this.request<MergedPresentationsOut, HTTPValidationError>({
        path: `/v1/presentations/merged`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags uploads
     * @name UploadPart
     * @summary Upload Part
     * @request PUT:/v1/uploads/{upload_id}/parts/{part_number}
     */
    uploadPart: (
      uploadId: string,
      partNumber: number,
      data: File,
      query?: {
        /**
         * Segment
         * @default 0
         */
        segment?: number;
        /** Copilot Session Id */
        copilot_session_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<PartReceived, HTTPValidationError>({
        path: `/v1/uploads/${uploadId}/parts/${partNumber}`,
        method: "PUT",
        query: query,
        body: data,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags uploads
     * @name CompleteUpload
     * @summary Complete Upload
     * @request POST:/v1/uploads/{upload_id}/complete
     */
    completeUpload: (
      uploadId: string,
      data: UploadCompleteIn,
      params: RequestParams = {},
    ) =>
      this.request<UploadCompleted, HTTPValidationError>({
        path: `/v1/uploads/${uploadId}/complete`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTask
     * @summary Get Task
     * @request GET:/v1/tasks/{task_id}
     */
    getTask: (taskId: string, params: RequestParams = {}) =>
      this.request<
        TaskOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/tasks/${taskId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name TaskEvents
     * @summary Task Events
     * @request GET:/v1/tasks/{task_id}/events
     */
    taskEvents: (taskId: string, params: RequestParams = {}) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/tasks/${taskId}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags tasks
     * @name GetTaskResult
     * @summary Get Task Result
     * @request GET:/v1/tasks/{task_id}/result
     */
    getTaskResult: (taskId: string, params: RequestParams = {}) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/tasks/${taskId}/result`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags me
     * @name GetMe
     * @summary Get Me
     * @request GET:/v1/me
     */
    getMe: (params: RequestParams = {}) =>
      this.request<MeOut, HTTPValidationError>({
        path: `/v1/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags partner
     * @name CreatePartnerSession
     * @summary Create Partner Session
     * @request POST:/v1/partner/sessions
     * @secure
     */
    createPartnerSession: (data: PartnerStartIn, params: RequestParams = {}) =>
      this.request<
        PartnerStartOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/partner/sessions`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags partner
     * @name ResolveLaunch
     * @summary Resolve Launch
     * @request GET:/v1/partner/launch
     */
    resolveLaunch: (
      query: {
        /** Token */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        LaunchResolveOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/partner/launch`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags partner
     * @name MeetingReport
     * @summary Meeting Report
     * @request GET:/v1/partner/meetings/{clientmeeting}
     * @secure
     */
    meetingReport: (clientmeeting: number, params: RequestParams = {}) =>
      this.request<
        MeetingReportOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/partner/meetings/${clientmeeting}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags partner
     * @name MeetingLaunchState
     * @summary Meeting Launch State
     * @request GET:/v1/partner/meetings/{clientmeeting}/launch
     * @secure
     */
    meetingLaunchState: (clientmeeting: number, params: RequestParams = {}) =>
      this.request<
        LaunchStateOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/partner/meetings/${clientmeeting}/launch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name CreateCopilotSession
     * @summary Create Copilot Session
     * @request POST:/v1/copilot/sessions
     */
    createCopilotSession: (data: CopilotCreateIn, params: RequestParams = {}) =>
      this.request<CopilotSessionCreated, HTTPValidationError>({
        path: `/v1/copilot/sessions`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name CopilotSessionEvents
     * @summary Copilot Session Events
     * @request GET:/v1/copilot/sessions/{session_id}/events
     */
    copilotSessionEvents: (sessionId: string, params: RequestParams = {}) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/sessions/${sessionId}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name FinalizeCopilotSession
     * @summary Finalize Copilot Session
     * @request POST:/v1/copilot/sessions/{session_id}/finalize
     */
    finalizeCopilotSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<
        CopilotFinalized,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/sessions/${sessionId}/finalize`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name GetCopilotSession
     * @summary Get Copilot Session
     * @request GET:/v1/copilot/sessions/{session_id}
     */
    getCopilotSession: (sessionId: string, params: RequestParams = {}) =>
      this.request<
        CopilotSessionOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/sessions/${sessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name GetCopilotSessionSummary
     * @summary Get Copilot Session Summary
     * @request GET:/v1/copilot/sessions/{session_id}/summary
     */
    getCopilotSessionSummary: (sessionId: string, params: RequestParams = {}) =>
      this.request<
        CopilotSummaryOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/sessions/${sessionId}/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name ListIntents
     * @summary List Intents
     * @request GET:/v1/copilot/intents
     */
    listIntents: (params: RequestParams = {}) =>
      this.request<
        IntentsOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/intents`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name ClaimIntent
     * @summary Claim Intent
     * @request POST:/v1/copilot/intents/{intent_id}/claim
     */
    claimIntent: (
      intentId: string,
      data: ClaimIn,
      params: RequestParams = {},
    ) =>
      this.request<
        IntentOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/intents/${intentId}/claim`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name ConfirmStarted
     * @summary Confirm Started
     * @request POST:/v1/copilot/intents/{intent_id}/started
     */
    confirmStarted: (
      intentId: string,
      data: ClaimIn,
      params: RequestParams = {},
    ) =>
      this.request<
        IntentOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/intents/${intentId}/started`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags copilot
     * @name ReleaseIntent
     * @summary Release Intent
     * @request POST:/v1/copilot/intents/{intent_id}/release
     */
    releaseIntent: (
      intentId: string,
      data: ReleaseIn,
      params: RequestParams = {},
    ) =>
      this.request<
        IntentOut,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/copilot/intents/${intentId}/release`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name Designers
     * @summary Designers
     * @request GET:/v1/dashboard/designers
     */
    designers: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DesignersResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name DesignerFlagStats
     * @summary Designer Flag Stats
     * @request GET:/v1/dashboard/designers/flag-stats
     */
    designerFlagStats: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DesignerFlagStatsResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers/flag-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name DesignerConversionStats
     * @summary Designer Conversion Stats
     * @request GET:/v1/dashboard/designers/conversion-stats
     */
    designerConversionStats: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DesignerConversionStatsResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers/conversion-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name TypicalIssues
     * @summary Typical Issues
     * @request GET:/v1/dashboard/typical-issues
     */
    typicalIssues: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /**
         * Limit
         * @min 1
         * @max 45
         * @default 5
         */
        limit?: number;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<TypicalIssuesResponse, HTTPValidationError>({
        path: `/v1/dashboard/typical-issues`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name SalonAnalytics
     * @summary Salon Analytics
     * @request GET:/v1/dashboard/salon-analytics
     */
    salonAnalytics: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonAnalyticsResponse, HTTPValidationError>({
        path: `/v1/dashboard/salon-analytics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name SalonAnalyticsInterpretation
     * @summary Salon Analytics Interpretation
     * @request GET:/v1/dashboard/salon-analytics/interpretation
     */
    salonAnalyticsInterpretation: (
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
        /** Salon Ids */
        salon_ids?: string[] | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SalonAnalyticsInterpretationResponse, HTTPValidationError>({
        path: `/v1/dashboard/salon-analytics/interpretation`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name DesignerPanelStats
     * @summary Designer Panel Stats
     * @request GET:/v1/dashboard/designers/{designer_email}/panel-stats
     */
    designerPanelStats: (
      designerEmail: string,
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DesignerPanelStatsResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers/${designerEmail}/panel-stats`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name DesignerClients
     * @summary Designer Clients
     * @request GET:/v1/dashboard/designers/{designer_email}/clients
     */
    designerClients: (
      designerEmail: string,
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<DesignerClientsResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers/${designerEmail}/clients`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name SetClientRoleplay
     * @summary Set Client Roleplay
     * @request PATCH:/v1/dashboard/designers/{designer_email}/clients/{client_profile}/roleplay
     */
    setClientRoleplay: (
      designerEmail: string,
      clientProfile: string,
      data: ClientRoleplayPatchIn,
      params: RequestParams = {},
    ) =>
      this.request<
        ClientRoleplayResponse,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/dashboard/designers/${designerEmail}/clients/${clientProfile}/roleplay`,
        method: "PATCH",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name ClientMeetings
     * @summary Client Meetings
     * @request GET:/v1/dashboard/designers/{designer_email}/clients/{client_profile}/meetings
     */
    clientMeetings: (
      designerEmail: string,
      clientProfile: string,
      query?: {
        /** From */
        from?: string | null;
        /** To */
        to?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClientMeetingsResponse, HTTPValidationError>({
        path: `/v1/dashboard/designers/${designerEmail}/clients/${clientProfile}/meetings`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name MeetingDetail
     * @summary Meeting Detail
     * @request GET:/v1/dashboard/meetings/{meeting_id}
     */
    meetingDetail: (meetingId: string, params: RequestParams = {}) =>
      this.request<
        MeetingDetailResponse,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/dashboard/meetings/${meetingId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags dashboard
     * @name MeetingAudio
     * @summary Meeting Audio
     * @request GET:/v1/dashboard/meetings/{meeting_id}/audio
     */
    meetingAudio: (
      meetingId: string,
      query: {
        /**
         * File Id
         * @minLength 1
         * @maxLength 512
         */
        file_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        any,
        | {
            /** Type */
            type: string;
            /** Title */
            title: string;
            /** Status */
            status: number;
            /** Detail */
            detail: string;
          }
        | HTTPValidationError
      >({
        path: `/v1/dashboard/meetings/${meetingId}/audio`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @name Features
     * @summary Features
     * @request GET:/v1/features
     */
    features: (params: RequestParams = {}) =>
      this.request<Record<string, boolean>, any>({
        path: `/v1/features`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
